var __webpack_exports__ = {};
/*!*******************************!*\
  !*** ./src/scripts/slider.js ***!
  \*******************************/
function Slider(slider) {
    if (!(slider instanceof Element)) {
      throw new Error('No slider passed in');
    }
  
    // select the elements needed for the slider
    this.slides = slider.querySelector('.c-slides');
    this.slider = slider;
    const prevButton = slider.querySelector('.goToPrev');
    const nextButton = slider.querySelector('.goToNext');
  
    // when this slider is created, run the start slider function
    this.startSlider();
    this.applyClasses();
  
    // Event listeners
    prevButton.addEventListener('click', () => this.move('back'));
    nextButton.addEventListener('click', () => this.move());
  }
  
  Slider.prototype.startSlider = function() {
    this.current =
      this.slider.querySelector('.current') || this.slides.firstElementChild;
    this.prev =
      this.current.previousElementSibling || this.slides.lastElementChild;
    this.next = this.current.nextElementSibling || this.slides.firstElementChild;
  };
  
  Slider.prototype.applyClasses = function() {
    this.current.classList.add('current');
    this.prev.classList.add('prev');
    this.next.classList.add('next');
  };
  
  Slider.prototype.move = function(direction) {
    // first strip all the classes off the current slides
    const classesToRemove = ['prev', 'current', 'next'];
    this.prev.classList.remove(...classesToRemove);
    this.current.classList.remove(...classesToRemove);
    this.next.classList.remove(...classesToRemove);
    if (direction === 'back') {
      // make an new array of the new values, and destructure them over and into the prev, current and next variables
      [this.prev, this.current, this.next] = [
        // get the prev slide, if there is none, get the last slide from the entire slider for wrapping
        this.prev.previousElementSibling || this.slides.lastElementChild,
        this.prev,
        this.current,
      ];
    } else {
      [this.prev, this.current, this.next] = [
        this.current,
        this.next,
        // get the next slide, or if it's at the end, loop around and grab the first slide
        this.next.nextElementSibling || this.slides.firstElementChild,
      ];
    }
  
    this.applyClasses();
  };
  

  const timer = document.querySelector('.c-slider').getAttribute('data-slider-timer');
  const mySlider = new Slider(document.querySelector('.c-slider'));
  window.mySlider = mySlider;
  setInterval(function(){ mySlider.move(); }, parseInt(timer));
  
